// removed by extract-text-webpack-plugin
module.exports = {"legend_wrapper":"legend_wrapper__2gLr0","legendCenter":"legendCenter__2ktFe","legendText":"legendText__3voBJ","legendColor":"legendColor__2rA5S","legendLabel":"legendLabel__17GU7"};


//////////////////
// WEBPACK FOOTER
// ./components/donor-donut-chart-legend/style.scss
// module id = UTu5
// module chunks = 0